"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addItemToCartErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.addItemToCartErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=addItemToCartErrors.js.map